const { onlyAlphaNumeric } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyAlphaNumeric(zipCode);
  if (zip.length <= 3) {
    return zip;
  }
  return `${zip.slice(0, 3)} ${zip.slice(3, 7)}`;
};

exports.countryDefinition = {
  country: 'Ireland',
  code: 'IE',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'City', width: 0.5 },
    stateCode: { label: 'County', width: 0.5 },
    zipCode: { label: 'Postcode', normalize: exports.zipCodeNormalize }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['stateCode'],
    ['zipCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city', 'stateCode'],
    ['zipCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^[A-Za-z0-9]{3}[A-Za-z0-9]{4}$/),
      error: 'Must be 7 letters or numbers like T37 F8HK'
    }
  ]
};
